module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_6005.f4393095.png";